<template>
  <transition name="fade">
    <div class="placeholder loading-skeleton-1" v-if="states.loadingResults || states.errorResults">
      <div v-if="states.errorResults" class="">
        <div class="text-xs-center">
          <v-icon color="error" x-large>error</v-icon>
        </div>
        <div class="headline text-xs-center">
          Sorry, we couldn't load the data. <br />
          Please contact Hatfield for assistance.
        </div>
        <div class="text-xs-center">
          <ContactSupport class="mt-3" />
        </div>
      </div>
      <div v-else-if="states.loadingResults">
        <div class="text-xs-center">
          <v-icon color="success" x-large>view_comfy</v-icon>
        </div>
        <div class="headline loading-dots">
          Loading
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const ingestionResults = createNamespacedHelpers('reviewingestionresults')

  export default {
    computed: {
      ...ingestionResults.mapState(['states']),
    },
  }
</script>

<style scoped>
  .placeholder {
    position: absolute;
    z-index: 200;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    display: flex;
    justify-content: center;
  }
</style>